<template>
	<div class="home">
		<!-- <a class="to-top" @click="$refs.fullpage.api.moveTo('page1')"></a> -->
		<full-page ref="fullpage" :options="options" id="fullpage">
			<div class="section">
				<div class="box">
					<div class="text">
						<div style="height: 157px; margin-top: -100px;">
							<transition name="BottomIn">
								<img v-show="page3.pic" src="../assets/images/banner_text_3.png" width="1087" height="158" />
							</transition>
						</div>
			
						<div style="height: 26px;">
							<transition name="BottomIn">
								<p v-show="page3.text" style="width: 1087px; padding-right: 230px;">用青柠买单更自由的购物吧</p>
							</transition>
						</div>
			
					</div>
					<img class="arrow" @click="$refs.fullpage.api.moveTo('page4')" src="../assets/images/index_arrow.png" width="85"
					 height="43" />
				</div>
			
			</div>
			<div class="section">
				<div class="box">
					<div class="text">
						<div style="height: 157px; margin-top: -100px;">
							<transition name="BottomIn">
								<img v-show="page1.pic" src="../assets/images/banner_text_1.png" width="710" height="157" />
							</transition>
						</div>

						<div style="height: 26px;">
							<transition name="BottomIn">
								<p v-show="page1.text" style="width: 710px; padding-right: 60px;">用青柠买单更自由的购物吧</p>
							</transition>
						</div>
					</div>
					<img class="arrow" @click="$refs.fullpage.api.moveTo('page2')" src="../assets/images/index_arrow.png" width="85"
					 height="43" />
				</div>

			</div>
			<div class="section">
				<div class="box">
					<div class="box">
						<div class="text">
							<div style="height: 157px; margin-top: -100px;">
								<transition name="BottomIn">
									<img v-show="page2.pic" src="../assets/images/banner_text_2.png" width="1032" height="153" />
								</transition>
							</div>

							<div style="height: 26px;">
								<transition name="BottomIn">
									<p v-show="page2.text" style="width: 1032px; padding-right: 200px;">用青柠买单更自由的购物吧</p>
								</transition>
							</div>

						</div>
						<img class="arrow" @click="$refs.fullpage.api.moveTo('page3')" src="../assets/images/index_arrow.png" width="85"
						 height="43" />
					</div>
				</div>

			</div>
			
			<div class="section">
				<div class="box">
					<div class="text">
						<div style="height: 157px; margin-top: -100px;">
							<transition name="BottomIn">
								<img v-show="page4.pic" src="../assets/images/banner_text_4.png" width="912" height="147" />
							</transition>
						</div>

						<div style="height: 26px;">
							<transition name="BottomIn">
								<p v-show="page4.text" style="width: 912px; padding-right: 140px;">用青柠买单更自由的购物吧</p>
							</transition>
						</div>

					</div>
					<img class="arrow" @click="$refs.fullpage.api.moveTo('page1')" src="../assets/images/index_arrow.png" width="85"
					 height="43" />
				</div>

			</div>
		</full-page>
		<div class="side-nav">
			<ul>
				<li @click="$refs.fullpage.api.moveTo('page1')" :class="{active:index === 1}"><i></i></li>
				<li @click="$refs.fullpage.api.moveTo('page2')" :class="{active:index === 2}"><i></i></li>
				<li @click="$refs.fullpage.api.moveTo('page3')" :class="{active:index === 3}"><i></i></li>
				<li @click="$refs.fullpage.api.moveTo('page4')" :class="{active:index === 4}"><i></i></li>
			</ul>
		</div>
		<ul class="info">
			
				<li>
					<transition name="BottomIn">
					<div class="in" v-show="icon1">
						<img src="../assets/images/index_icon_1.png" width="50" height="50" />
						<i></i>
						<div class="text">
							<p>先买后付</p>
							<span>先买后付款</span>
						</div>
					</div>
					</transition>
				</li>
			
			
				<li style="margin: 0 250px;">
					<transition name="BottomIn">
					<div class="in" v-show="icon2">
						<img src="../assets/images/index_icon_2.png" width="50" height="50" />
						<i></i>
						<div class="text">
							<p>零负担购</p>
							<span>四期免息无压力</span>
						</div>
					</div>
					</transition>
				</li>
			
			
				<li>
					<transition name="BottomIn">
					<div class="in" v-show="icon3">
						<img src="../assets/images/index_icon_3.png" width="50" height="50" />
						<i></i>
						<div class="text">
							<p>无忧操作</p>
							<span>账单到期自动还</span>
						</div>
					</div>
					</transition>
				</li>
			
			
			
			
		</ul>
		<div class="cover"></div>
		<div class="cover_back"></div>
		<div class="video">
			<video-player class="video-player-box" ref="videoPlayer" :options="playerOptions" :playsinline="true"
			 customEventName="customstatechangedeventname">
			</video-player>
		</div>
	</div>
</template>

<script>
	// require styles
	import 'video.js/dist/video-js.css'

	import {
		videoPlayer
	} from 'vue-video-player'
	export default {
		data() {
			return {
				playerOptions: {
					// videojs options
					autoplay:true,
					muted: true,
					loop:true,
					// fluid:true,
					sources: [{
						type: "video/mp4",
						src: "v1.mp4"
					}],
					poster: "",
					width:document.documentElement.clientWidth,
					height:document.documentElement.clientHeight,
				},
				index: 1,
				page1: {
					pic: false,
					text: false,
				},
				page2: {
					pic: false,
					text: false,
				},
				page3: {
					pic: false,
					text: false,
				},
				page4: {
					pic: false,
					text: false,
				},
				icon1:false,
				icon2:false,
				icon3:false,
				options: {
					anchors: ['page1', 'page2', 'page3', 'page4'],
					lockAnchors: true,
					afterLoad: this.afterLoad
				},
			}
		},
		created() {
			
		},
		mounted() {
			setTimeout(() => {
				this.icon1 = true
			}, 1000);
			setTimeout(() => {
				this.icon2 = true
			}, 1300);
			setTimeout(() => {
				this.icon3 = true
			}, 1600);
		},
		computed: {
			player() {
				return this.$refs.videoPlayer.player
			}
		},
		watch: {},
		methods: {
			afterLoad(origin, destination) {
				if (destination.anchor === "page1") {
					this.index = 1
					this.playerOptions.sources[0].src = 'v3.mp4'
					setTimeout(() => {
						this.page3.pic = true
					}, 500);
					setTimeout(() => {
						this.page3.text = true
					}, 1000);
				}
				if (destination.anchor === "page2") {
					this.index = 2
					this.playerOptions.sources[0].src = 'v1.mp4'
					this.page1.pic = true
					setTimeout(() => {
						this.page1.text = true
					}, 1000);
				}
				if (destination.anchor === "page3") {
					this.index = 3
					this.playerOptions.sources[0].src = 'v2.mp4'
					this.page2.pic = true
					setTimeout(() => {
						this.page2.text = true
					}, 1000);
				}
				if (destination.anchor === "page4") {
					this.index = 4
					this.playerOptions.sources[0].src = 'v4.mp4'
					this.page4.pic = true
					setTimeout(() => {
						this.page4.text = true
					}, 1000);

				}

			},
		},
		components: {
			videoPlayer
		}
	}
</script>

<style>
	.video-js .vjs-tech{
	   object-fit:cover;
	   width: 100vw;
	   height: 100vh;
	}
	.vjs-control-bar{
		display: none !important;
	}
</style>

<style scoped lang="less">
	.video {
		position: fixed;
		width: 100vw;
		height: 100vh;
		z-index: -3;
		left: 0;
		top: 0;
	}
	.cover{
		width: 100vw;
		height: 50vh;
		position: fixed;
		z-index: -1;
		left: 0;
		bottom: 40px;
		background: linear-gradient(360deg, rgba(12, 233, 172, 0.49) 0%, rgba(13, 233, 176, 0) 100%);
	}
	.cover_back{
		width: 100vw;
		height: 100vh;
		position: fixed;
		z-index: -2;
		left: 0;
		top: 0;
		background: rgba(0,0,0,0.3);
	}
	
	.side-nav {
		position: fixed;
		z-index: 2;
		right: 0;
		height: 90px;
		top: 50%;
		margin-top: -45px;

		li {
			display: flex;
			align-items: center;
			padding-right: 20px;
			padding-left: 20px;
			margin: 10px 0;
			cursor: pointer;

			i {
				display: inline-block;
				width: 7px;
				height: 7px;
				border: #fff 1px solid;
				border-radius: 50%;
				transition: all 0.3s ease-in-out;
				box-sizing: border-box;
			}

			&:hover {
				i {
					background: #fff;
				}
			}

			&.active {
				i {
					width: 7px;
					height: 19px;
					background: #00FFBD;
					border: none;
					box-shadow: 0px 0px 3px 0px #00FFBD;
					border-radius: 3px;
				}
			}

		}
	}

	.arrow {
		position: absolute;
		z-index: 100;
		bottom: 150px;
		left: 50%;
		margin-left: -42.5px;
		cursor: pointer;
		-webkit-animation: move 1s infinite;
		-moz-animation: move 1s infinite;
		-ms-animation: move 1s infinite;
		animation: move 1s infinite;
	}

	@keyframes move {
		0% {
			transform: translateY(0px);
		}

		50% {
			transform: translateY(10px);
		}

		100% {
			transform: translateY(0px);
		}
	}

	.info {
		display: flex;
		justify-content: center;
		position: fixed;
		z-index: 100;
		bottom: 80px;
		left: 0;
		right: 0;

		li {
			width: 220px;
			.in{
				display: flex;
				align-items: center;
				color: #fff;
			}
			i {
				width: 1px;
				height: 16px;
				background: #fff;
				margin: 0 15px;
			}

			.text {
				p {
					font-size: 20px;
					font-weight: 500;
					letter-spacing: 7px;
					text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.13);
				}

				span {
					font-size: 15px;
					text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.13);
					letter-spacing: 2px;
				}
			}

		}
	}

	.box {
		width: 100vw;
		height: 100vh;
		position: relative;

		.text {
			position: absolute;
			left: 0;
			top: 0;
			width: 100vw;
			height: 100vh;
			z-index: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;

			p {
				box-sizing: border-box;
				text-align: right;
				color: #fff;
				font-size: 18px;
				letter-spacing: 7px;
				text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
			}
		}
	}
</style>
